import { useState, useEffect, useCallback } from 'react';
import { databaseService } from '../services/databaseService';
import type { Student } from '../types/student';

export function useTopStudents(limitCount: number = 3) {
  const [students, setStudents] = useState<Student[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTopStudents = useCallback(async () => {
    try {
      setLoading(true);

      // Tenta buscar do Supabase primeiro
      const supabaseData = await databaseService.fetchData('students', {
        source: 'supabase',
        orderBy: 'interaction_points',
        limit: limitCount
      });

      // Se não houver dados no Supabase, tenta o Firebase
      const data = supabaseData.length > 0 ? supabaseData :
        await databaseService.fetchData('students', {
          source: 'firebase',
          orderBy: 'interaction_points',
          limit: limitCount
        });

      setStudents(data as Student[]);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  }, [limitCount]);

  useEffect(() => {
    fetchTopStudents();
  }, [fetchTopStudents]);

  return { students, loading, error, refresh: fetchTopStudents };
}